import { Component } from '@angular/core'

@Component({
    selector: 'app-contest-live-stream-page',
    templateUrl: './contest-live-stream.page.html',
    styleUrls: ['./contest-live-stream.page.scss'],
})
export class ContestLiveStreamPage {
}
